import Delay from 'Library/delay';
import { qq } from 'bobjoll/ts/library/dom';

export default class Slider {
    private active: number = 0;
    private prev: number = 0;
    private next: number = 0;
    private delay: number = 50;
    private slides: number;
    private interval: any;
    private timeout: number;
    private wrapper: HTMLElement;
    private navigation: HTMLElement[];
    private bullets: HTMLElement[];
    private progress: HTMLElement;
    private progressNumber: HTMLElement;

    constructor(selector: HTMLElement, timeout: number = 10000) {
        const navigation = qq('.slider__navigation', selector);
        const progress = <HTMLElement>selector.querySelector('.progress__bar');
        const progressNumber = <HTMLElement>selector.querySelector('.slider__number');

        this.timeout = timeout - this.delay;
        this.wrapper = selector;
        this.slides = qq('.slider__item', selector).length;
        this.bullets = qq('.slider--controls button');
        this.navigation = navigation;

        if (progress) {
            this.progress = progress;
        }

        if (progressNumber) {
            this.progressNumber = progressNumber;
        }

        if (3 > this.slides) {
            console.error(`Slider, you don't have enough elements to start the slideshow.`);

            return;
        }

        this.start();
    }

    public async direction(direction: 'next' |  'prev') {
        if (this.progress) {
            this.progress.classList.remove('animate');
        }

        await Delay(this.delay);

        if ('next' === direction) {
            this.active++;
        }

        if ('prev' === direction) {
            this.active--;
        }

        this.wrapper.classList.remove('slider--next', 'slider--prev');
        this.wrapper.classList.add(`slider--${direction}`);

        this.update();
    }

    private start() {
        this.navigation.forEach(button => {
            button.addEventListener('click', () => {
                this.stop(); this.direction(<'next' |  'prev'>button.dataset.direction ||  'next')
            });
        });

        this.bullets.forEach(button => {
            button.addEventListener('click', () => {
                this.active = parseFloat(button.dataset.index || '1');
                this.update();
            })
        });

        this.direction('next');

        this.interval = setInterval(() => this.direction('next'), this.timeout);
    }

    private stop() {
        clearInterval(this.interval);

        this.interval = setInterval(() => this.direction('next'), this.timeout);
    }

    private update() {
        this.updateIndex();

        qq('.slider__item', this.wrapper).forEach((item, index) => {
            item.classList.remove('is-prev', 'is-next', 'is-active');

            if (this.prev == (item.dataset.index ||  1)) {
                item.classList.add('is-prev');
            }

            if (this.next == (item.dataset.index ||  1)) {
                item.classList.add('is-next');
            }

            if (this.active == (item.dataset.index ||  1)) {
                item.classList.add('is-active');
            }
        });

        this.bullets.forEach(button => {
            button.classList.remove('active');

            if (this.active == (button.dataset.index || 1)) {
                button.classList.add('active');
            }
        });

        if (this.progress) {
            this.progress.classList.add('animate');
        }

        if (this.progressNumber) {
            this.progressNumber.innerHTML = `${this.active} / ${this.slides}`;
        }
    }

    private updateIndex() {
        if (this.active > this.slides) {
            this.active = 1;
        }

        if (this.active < 1) {
            this.active = this.slides;
        }

        this.prev = this.active - 1;
        this.next = this.active + 1;

        if (this.prev > this.slides) {
            this.prev = 1;
        }

        if (this.prev < 1) {
            this.prev = this.slides;
        }

        if (this.next > this.slides) {
            this.next = 1;
        }

        if (this.next < 1) {
            this.next = this.slides;
        }
    }
}